import moment from 'moment';

// * Display MD as MM/DD/YYYY
const formatMD = (date: string, divider = '/') => (date ? moment(date).format(`MM${divider}DD${divider}YYYY`) : null);

export default formatMD;
